import { render, staticRenderFns } from "./VDesc.vue?vue&type=template&id=3d7c49be&scoped=true"
import script from "./VDesc.vue?vue&type=script&lang=js"
export * from "./VDesc.vue?vue&type=script&lang=js"
import style0 from "./VDesc.vue?vue&type=style&index=0&id=3d7c49be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c49be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7c49be')) {
      api.createRecord('3d7c49be', component.options)
    } else {
      api.reload('3d7c49be', component.options)
    }
    module.hot.accept("./VDesc.vue?vue&type=template&id=3d7c49be&scoped=true", function () {
      api.rerender('3d7c49be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/Interface/VDesc.vue"
export default component.exports